module.exports = __webpack_public_path__ + "img/check-square.23ef48aa.svg";